import Firebase from 'firebase'

const config = {
  apiKey: 'AIzaSyDe44Xq6yp5JFV21V4AJr_i3uaGo4jlX6U',
  authDomain: 'liverun-45203.firebaseapp.com',
  databaseURL: 'https://liverun-45203.firebaseio.com',
  projectId: 'liverun-45203',
  storageBucket: 'liverun-45203.appspot.com',
  messagingSenderId: '142247574738'


  //Test firebase insecure rule with this database

  // apiKey: 'AIzaSyAyX88sE5Rf2vJ8EW3v3v3pcH1DqzDuhjw',
  // authDomain: 'liverun-staging.firebaseapp.com',
  // databaseURL:'https://liverun-staging.firebaseio.com/',
  // projectId: 'liverun-staging',
  // storageBucket: 'liverun-staging.appspot.com',
  // messagingSenderId: '551144111565'


  // apiKey: "AIzaSyC-tloEHYtc323ncMk4l7pcn9-yhcdj2ZM",
  // authDomain: "liverrun-merged.firebaseapp.com",
  // databaseURL: "https://liverrun-merged.firebaseio.com",
  // projectId: "liverrun-merged",
  // storageBucket: "liverrun-merged.appspot.com",
  // messagingSenderId: "164960924206"


}

const app = Firebase.initializeApp(config)

export const db = app.database()

//function to delete a node from firebase
export function deleteNode(node) {
  db.ref(node).remove().then(r => {
    console.log('Node deleted >>> ' +  node);
  })
}

//delete node from firebase with a key
export function deleteLocationData(runId) {
  db.ref("https://liverun-45203.firebaseio.com/locations/").child(runId).remove().then(r => {
    console.log('Node deleted >>> ' +  node);
  })
}



// WEBPACK FOOTER //
// ./src/firebase.js